import { getServerURL } from "./serverUrl";

const AUTO_LOGOUT_DEBUG_STORAGE_KEY = "auto_logout_debug_events";
const AUTO_LOGOUT_DEBUG_EVENT_LIMIT = 50;

const isAutoLogoutDebugEnabled = () => {
  try {
    return new URL(getServerURL()).hostname === "unity-rd3.nuclias.com";
  } catch {
    return false;
  }
};

export const logAutoLogoutDiagnostic = (event, details = {}) => {
  if (!isAutoLogoutDebugEnabled()) {
    return;
  }

  const diagnostic = {
    event,
    at: new Date().toISOString(),
    visibility: document.visibilityState,
    ...details,
  };

  console.debug("[auto-logout]", diagnostic);

  try {
    const events = JSON.parse(
      localStorage.getItem(AUTO_LOGOUT_DEBUG_STORAGE_KEY) || "[]",
    );
    const recentEvents = Array.isArray(events) ? events : [];
    recentEvents.push(diagnostic);
    localStorage.setItem(
      AUTO_LOGOUT_DEBUG_STORAGE_KEY,
      JSON.stringify(recentEvents.slice(-AUTO_LOGOUT_DEBUG_EVENT_LIMIT)),
    );
  } catch (error) {
    console.warn("[auto-logout] Failed to persist diagnostics", error);
  }
};
